import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { lazy, Suspense, useState, useEffect, useMemo } from 'react';
import ReactModal from 'react-modal';
import Slider from 'react-slick';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/mobile.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';
import Header from "./components/Header";
import Footer from "./components/Footer";

const Home = lazy(() => import("./pages/Home"));
const Homepage = lazy(() => import('./pages/Homepage.jsx'));
const AcademicResources = lazy(() => import("./pages/AcademicResources.jsx"));
const TeachingStaff = lazy(() => import("./pages/TeachingStaff"));
const Results = lazy(() => import("./pages/Result.jsx"));
const Gallery = lazy(() => import("./pages/Gallery.jsx"));
const SpecialFeatures = lazy(() => import("./pages/SpecialFeatures.jsx"));
const Alumni = lazy(() => import("./pages/Alumni.jsx"));
const Contact = lazy(() => import("./pages/Contact.jsx"));
const AtalTinkering = lazy(() => import("./pages/AtalTinkering.Jsx"));
const Gymnastics = lazy(() => import("./pages/Gymnatic.jsx"));
const TableTennis = lazy(() => import("./pages/TableTennis.jsx"));
const Transport = lazy(() => import("./pages/Transport.jsx"));
const Activities = lazy(() => import("./pages/Activities.jsx"));
const Calender = lazy(() => import("./pages/Calendar.jsx"));
const Sports = lazy(() => import("./pages/Sports.jsx"));
const Achievements = lazy(() => import("./pages/Achievements.jsx"));
const HouseSystem = lazy(() => import("./pages/HouseSystem.jsx"));
const PlannersSyllabus = lazy(() => import("./pages/PlannerSyllabus.jsx"));
const Curriculum = lazy(() => import("./pages/Curriculum.jsx"));
const Datesheets = lazy(() => import("./pages/Datesheets.jsx"));
const Primary = lazy(() => import("./pages/Primary.jsx"));
const PrePrimary = lazy(() => import("./pages/PrePrimary.jsx"));
const MiddleWing = lazy(() => import("./pages/MiddleWing.jsx"));
const Secondary = lazy(() => import("./pages/Secondary.jsx"));
const CbseMandatory = lazy(() => import("./pages/CbseMandatory.jsx"));
const BritishCouncil = lazy(() => import("./pages/BritishCouncil.jsx"));
const Admissions = lazy(() => import("./pages/Admissions.jsx"));
const Microsoft = lazy(() => import("./pages/Microsoft.jsx"));
const TransferCertificates = lazy(() => import("./pages/TransferCertificates.jsx"));
const EnteryForm = lazy(() => import("./pages/EnteryForm.jsx"));
const GermanGateway = lazy(() => import("./pages/GermanGateway.jsx"));
const CambridgeEnglish = lazy(() => import("./pages/CambridgeEnglish.jsx"));

const POPUP_SLIDES = [
  { src: require("./assets/images/popup-slider/popup-04.jpeg"), alt: "Rainbow International School" },
  { src: require("./assets/images/popup-slider/popup-01.png"), alt: "Admissions" },
  { src: require("./assets/images/popup-slider/popup-02.jpeg"), alt: "School banner" },
  { src: require("./assets/images/popup-slider/popup-03.jpg"), alt: "School" },
];

const POPUP_LINK =
  "https://www.facebook.com/story.php?story_fbid=1064220435492393&id=100057133403626&rdid=d9tqrXLQOdmahOHP";

function App() {
  const [isBannerOpen, setIsBannerOpen] = useState(false);

  const popupSliderSettings = useMemo(
    () => ({
      dots: true,
      arrows: false,
      infinite: POPUP_SLIDES.length > 1,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3500,
      pauseOnHover: true,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
      adaptiveHeight: true,
    }),
    []
  );

  useEffect(() => {
    const currentRoute = window.location.pathname;
    if (currentRoute === '/') {
      setIsBannerOpen(true);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    import('aos').then((mod) => {
      if (cancelled) return;
      const AOS = mod.default;
      AOS.init({
        disable: false,
        startEvent: 'DOMContentLoaded',
        initClassName: 'aos-init',
        animatedClassName: 'aos-animate',
        useClassNames: false,
        disableMutationObserver: false,
        debounceDelay: 50,
        throttleDelay: 99,
        offset: 120,
        delay: 0,
        duration: 800,
        easing: 'ease',
        once: true,
        mirror: false,
        anchorPlacement: 'top-bottom',
      });
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    import('../node_modules/bootstrap/dist/js/bootstrap.bundle.js');
  }, []);

  const closeBanner = () => {
    setIsBannerOpen(false);
  };

  return (
    <div className={'website'}>
      <Router>
        <Header />
        <Suspense fallback={<div className="route-loading" aria-hidden="true" />}>
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Homepage />} />
            <Route path="/transfer-certificate" element={<TransferCertificates />} />
            <Route path="/teaching-staff" element={<TeachingStaff />} />
            <Route path="/atal-tinkering" element={<AtalTinkering />} />
            <Route path="/table-tennis" element={<TableTennis />} />
            <Route path="/gymnastics" element={<Gymnastics />} />
            <Route path="/german-gateway" element={<GermanGateway />} />
            <Route path="/cambridge" element={<CambridgeEnglish />} />
            <Route path="/academic-resources" element={<AcademicResources />} />
            <Route path="/admission" element={<Admissions />} />
            <Route path="/results" element={<Results />} />
            <Route path="/alumni" element={<Alumni />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/curriculum" element={<Curriculum />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/special-features" element={<SpecialFeatures />} />
            <Route path="/transport" element={<Transport />} />
            <Route path="/calender" element={<Calender />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/house-system" element={<HouseSystem />} />
            <Route path="/datesheets" element={<Datesheets />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/primary" element={<Primary />} />
            <Route path="/pre-primary" element={<PrePrimary />} />
            <Route path="/middle-wing" element={<MiddleWing />} />
            <Route path="/secondary" element={<Secondary />} />
            <Route path="/planners-of-syllabus" element={<PlannersSyllabus />} />
            <Route path="/cbse-mandatory" element={<CbseMandatory />} />
            <Route path="/british-council" element={<BritishCouncil />} />
            <Route path="/microsoft" element={<Microsoft />} />
            <Route path="/entery-form" element={<EnteryForm />} />
          </Routes>
        </Suspense>
        <Footer />
        <ReactModal className="banner-web" isOpen={isBannerOpen} onRequestClose={closeBanner} ariaHideApp={false} contentLabel="Admission Form Modal">
          <button className="close" onClick={closeBanner}>Close</button>
          {isBannerOpen && (
            <div className="popup_design_op onload-popup">
              <Slider {...popupSliderSettings} className="onload-popup-slider">
                {POPUP_SLIDES.map((slide, index) => (
                  <div key={index}>
                    <a
                      href={POPUP_LINK}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeBanner}
                    >
                      <img src={slide.src} alt={slide.alt} />
                    </a>
                  </div>
                ))}
              </Slider>
            </div>
          )}
        </ReactModal>
      </Router>
    </div>
  );
}

export default App;
